'use es6';

export const getProfileListingDetails = state => state.profile.listing.details;
export const getProfileListingRequestError = state => state.profile.listing.detailsRequestError;
export const getProfileListingRequestState = state => state.profile.listing.detailsRequestState;